import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import LrfService from '../../../../../services/lrf-auth';
import { Link } from 'react-router-dom';



const FormBusca = (props) => {
    const [ano, setAno] = useState("");
    const [bimestre, setBimestre] = useState("");



    const busca = async (query) => {
        if (query == "") {
            props.setAindaTem(true)
            await props.fetchLrfIn()
            setAno("")
            setBimestre("")
        } else {
            var response = await LrfService.buscar(query)
            if (response.data.length >= 1) {
                props.setLrfs(response.data)
                props.setAindaTem(false)
                props.setVazio(false)
                setAno("")
                setBimestre("")
            } else {
                props.setVazio(true)
                setAno("")
                setBimestre("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (bimestre !== "false" && bimestre !== "") prepQuery = prepQuery + `bimestre=${bimestre}`;
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="Bimestre">
                                <FloatingLabel
                                    label="Bimestre"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Bimestre"
                                        name="bimestre"
                                        onChange={e => setBimestre(e.target.value)}
                                    >
                                        <option value="false">TODOS</option>
                                        <option value="1bim">1º Bimestre (RREO)</option>
                                        <option value="2bim">2º Bimestre (RREO)</option>
                                        <option value="3bim">3º Bimestre (RREO)</option>
                                        <option value="1sem">1º Semestre (RGF)</option>
                                        <option value="4bim">4º Bimestre (RREO)</option>
                                        <option value="5bim">5º Bimestre (RREO)</option>
                                        <option value="6bim">6º Bimestre (RREO)</option>
                                        <option value="2sem">2º Semestre (RGF)</option>
                                        <option value="1qua">1º Quadrimestre (RGF)</option>
                                        <option value="2qua">2º Quadrimestre (RGF)</option>
                                        <option value="3qua">3º Quadrimestre (RGF)</option>
                                        <option value="ano">Anual (DCRGF)</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/lrf'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
